"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  analyzeBreakpoints: function analyzeBreakpoints() {
    return _analyzeBreakpoints;
  },
  arrayToObjectNotation: function arrayToObjectNotation() {
    return _arrayToObjectNotation;
  },
  breakpoints: function breakpoints() {
    return _breakpoints;
  },
  isCustomBreakpoint: function isCustomBreakpoint() {
    return _isCustomBreakpoint;
  },
  isResponsiveObjectLike: function isResponsiveObjectLike() {
    return _isResponsiveObjectLike;
  },
  mapResponsive: function mapResponsive() {
    return _mapResponsive;
  },
  objectToArrayNotation: function objectToArrayNotation() {
    return _objectToArrayNotation;
  },
  px: function px() {
    return _px;
  },
  toMediaQueryString: function toMediaQueryString() {
    return _toMediaQueryString;
  }
});

module.exports = __toCommonJS(src_exports); // src/responsive.ts

var import_shared_utils = require("@chakra-ui/shared-utils");

var _breakpoints = Object.freeze(["base", "sm", "md", "lg", "xl", "2xl"]);

function _mapResponsive(prop, mapper) {
  if (Array.isArray(prop)) {
    return prop.map(function (item) {
      return item === null ? null : mapper(item);
    });
  }

  if ((0, import_shared_utils.isObject)(prop)) {
    return Object.keys(prop).reduce(function (result, key) {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }

  if (prop != null) {
    return mapper(prop);
  }

  return null;
}

function _objectToArrayNotation(obj) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _breakpoints;
  var result = bps.map(function (br) {
    var _a;

    return (_a = obj[br]) != null ? _a : null;
  });
  var lastItem = result[result.length - 1];

  while (lastItem === null) {
    result.pop();
  }

  return result;
}

function _arrayToObjectNotation(values) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _breakpoints;
  var result = {};
  values.forEach(function (value, index) {
    var key = bps[index];
    if (value == null) return;
    result[key] = value;
  });
  return result;
}

function _isResponsiveObjectLike(obj) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _breakpoints;
  var keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every(function (key) {
    return bps.includes(key);
  });
}

var _isCustomBreakpoint = function _isCustomBreakpoint(v) {
  return Number.isNaN(Number(v));
}; // src/breakpoint.ts


var import_shared_utils2 = require("@chakra-ui/shared-utils");

function getLastItem(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}

function analyzeCSSValue(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
}

function _px(value) {
  if (value == null) return value;

  var _analyzeCSSValue = analyzeCSSValue(value),
      unitless = _analyzeCSSValue.unitless;

  return unitless || typeof value === "number" ? "".concat(value, "px") : value;
}

var sortByBreakpointValue = function sortByBreakpointValue(a, b) {
  return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};

var sortBps = function sortBps(breakpoints2) {
  return Object.fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
};

function normalize(breakpoints2) {
  var sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}

function keys(breakpoints2) {
  var value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}

function subtract(value) {
  var _a;

  if (!value) return value;
  value = (_a = _px(value)) != null ? _a : value;
  var OFFSET = -0.02;
  return typeof value === "number" ? "".concat(value + OFFSET) : value.replace(/([0-9]+\.?[0-9]*)/, function (m) {
    return "".concat(parseFloat(m) + OFFSET);
  });
}

function _toMediaQueryString(min, max) {
  var query = ["@media screen"];
  if (min) query.push("and", "(min-width: ".concat(_px(min), ")"));
  if (max) query.push("and", "(max-width: ".concat(_px(max), ")"));
  return query.join(" ");
}

function _analyzeBreakpoints(breakpoints2) {
  var _a;

  if (!breakpoints2) return null;
  breakpoints2.base = (_a = breakpoints2.base) != null ? _a : "0px";
  var normalized = normalize(breakpoints2);
  var queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(function (_ref, index, entry) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpoint = _ref2[0],
        minW = _ref2[1];

    var _a2;

    var _ref3 = (_a2 = entry[index + 1]) != null ? _a2 : [],
        _ref4 = _slicedToArray(_ref3, 2),
        maxW = _ref4[1];

    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint: breakpoint,
      minW: minW,
      maxW: maxW,
      maxWQuery: _toMediaQueryString(null, maxW),
      minWQuery: _toMediaQueryString(minW),
      minMaxQuery: _toMediaQueryString(minW, maxW)
    };
  });

  var _keys = keys(breakpoints2);

  var _keysArr = Array.from(_keys.values());

  return {
    keys: _keys,
    normalized: normalized,
    isResponsive: function isResponsive(test) {
      var keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every(function (key) {
        return _keys.has(key);
      });
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    get: function get(key) {
      return queries.find(function (q) {
        return q.breakpoint === key;
      });
    },
    media: [null].concat(_toConsumableArray(normalized.map(function (minW) {
      return _toMediaQueryString(minW);
    }).slice(1))),
    toArrayValue: function toArrayValue(test) {
      if (!(0, import_shared_utils2.isObject)(test)) {
        throw new Error("toArrayValue: value must be an object");
      }

      var result = _keysArr.map(function (bp) {
        var _a2;

        return (_a2 = test[bp]) != null ? _a2 : null;
      });

      while (getLastItem(result) === null) {
        result.pop();
      }

      return result;
    },
    toObjectValue: function toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }

      return test.reduce(function (acc, value, index) {
        var key = _keysArr[index];
        if (key != null && value != null) acc[key] = value;
        return acc;
      }, {});
    }
  };
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  analyzeBreakpoints: _analyzeBreakpoints,
  arrayToObjectNotation: _arrayToObjectNotation,
  breakpoints: _breakpoints,
  isCustomBreakpoint: _isCustomBreakpoint,
  isResponsiveObjectLike: _isResponsiveObjectLike,
  mapResponsive: _mapResponsive,
  objectToArrayNotation: _objectToArrayNotation,
  px: _px,
  toMediaQueryString: _toMediaQueryString
});